import React from "react";
import { Moon, Sun, Globe, Coins } from "lucide-react";
import { useTheme, useLocale, useCurrency } from "@/context/AppContext";
import { LANGUAGES, CURRENCIES } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <Button variant="ghost" size="icon" onClick={toggle} data-testid="theme-toggle" aria-label="theme">
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}

export function LanguageMenu() {
  const { locale, setLocale } = useLocale();
  const active = LANGUAGES.find((l) => l.code === locale) || LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5" data-testid="language-menu">
          <Globe className="h-4 w-4" /> <span>{active.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => setLocale(l.code)} data-testid={`lang-${l.code}`}>
            {l.flag} {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function CurrencyMenu() {
  const { currency, setCurrency } = useCurrency();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 font-mono" data-testid="currency-menu">
          <Coins className="h-4 w-4" /> {currency}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-72 overflow-y-auto">
        {CURRENCIES.map((c) => (
          <DropdownMenuItem key={c.code} onClick={() => setCurrency(c.code)} data-testid={`cur-${c.code}`}>
            <span className="font-mono w-10">{c.symbol}</span> {c.code}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function RiskBadge({ level }) {
  const map = {
    BAIXO: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
    "MÉDIO": "bg-amber-500/15 text-amber-500 border-amber-500/30",
    ALTO: "bg-red-500/15 text-red-500 border-red-500/30",
  };
  const cls = map[level] || "bg-muted text-muted-foreground border-border";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`} data-testid="risk-badge">
      {level || "—"}
    </span>
  );
}
